<section class="container">
  <div class="page-header-container">
    <div class="page-title-container">
      <button class="back_icon me-2" mat-icon-button (click)="goBack()">
        <i class="fa-solid fa-arrow-left"></i>
      </button>
      <h1 class="page-title">
        <span translate>Assignment:</span>
        {{ assignment.title }}
      </h1>
    </div>
  </div>

  <div class="bg-white">
    <div class="details-grid p-4">
      <!-- Academic Year -->
      <div class="detail-card" *ngFor="let detail of assignmentDetails">
        <div class="detail-card-content">
          <i
            [class]="detail.icon"
            class="icon_style"
            *ngIf="detail.type !== 'status'"
          ></i>

          <!-- Status Icon -->
          <i
            *ngIf="detail.type === 'status'"
            [class]="getStatusIcon(detail.status)"
            class="icon_style"
          ></i>

          <div>
            <h4>{{ detail.label }}</h4>

            <!-- Normal Text -->
            <p *ngIf="detail.type === 'text'">{{ detail.value }}</p>

            <!-- Status -->
            <span
              *ngIf="detail.type === 'status'"
              class="status-chip"
              [ngClass]="getStatusClass(detail.status)"
            >
              <i
                [ngClass]="getStatusIcon(detail.status)"
                class="status-icon"
              ></i>
              {{ detail.status }}
            </span>

            <!-- Progress -->
            <ng-container *ngIf="detail.type === 'progress'">
              <mat-progress-bar
                [value]="
                  (detail.submissions.submitted / detail.submissions.total) *
                  100
                "
                color="primary"
              ></mat-progress-bar>
              <p class="mt-1">
                {{ detail.submissions.submitted }}/{{
                  detail.submissions.total
                }}
                <span translate>Submitted</span>
              </p>
            </ng-container>
          </div>
        </div>
      </div>
    </div>
    <mat-divider class="m-3"></mat-divider>
    <div class="questions-container p-4">
      <h3 translate>Questions</h3>
      <div class="questions-list">
        <div
          class="question-card"
          *ngFor="let question of assignment.questions; let i = index"
        >
          <p>
            <strong>{{ i + 1 }}.</strong> {{ question }}
          </p>
          <!-- <span *ngIf="question.attachment" class="attachment">
          <i class="fa-solid fa-paperclip"></i>
          {{ question.attachment }}
        </span> -->
        </div>
      </div>
    </div>

    <!-- Action Buttons -->
    <div class="action-buttons p-3">
      <button matButton="outlined">
        <i class="fa-solid fa-pen"></i> <span translate>Edit Assignment</span>
      </button>
      <button mat-raised-button color="primary" (click)="viewSubmissionPage()">
        <i class="fa-solid fa-eye"></i> <span translate>View Submissions</span>
      </button>
    </div>
  </div>
</section>
